import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import { jsPDF } from 'jspdf';
import XLSX from 'sheetjs-style';
import 'jspdf-autotable';
import 'assets/css/table.css';
import DateFilter from '@inovua/reactdatagrid-community/DateFilter';
import moment from 'moment';
import Axios from 'axios';

import dateformater from 'dateformat';
import common from '../../../commonData';
import NavMenu from './navbar';
import ActionBtn from './gridactionbtn';
import AddFacture from './addFacture';
import AddSortie from './addSortie';
import NumberToLetter from '../../../converter';
import FilterModale from './filterModal';
import FacturerModal from './facturerModal';
import ShowFacture from './showFacture';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter';

function IndexFacture({
    rows,
    // setShowAddOrEdit,
    keys,
    setIsSave,
    setMsg,
    setMsgravity,
    setShowFilterModals,
    actualise,
    setActualise,
    setDataFact,
    // setParamShow,
    paramShow,
    getFacture,
    getProforma,
    showfacture,
    factureDetail,
    showDetailFactureModal,
    handleClose,
    clients
}) {
    window.moment = moment;
    const [selected, setSelected] = useState({});
    const [load, setLoad] = useState(false);
    const [isLoading, setIsLoad] = useState(false);
    const [datafacture, setDatafacture] = useState([]);
    const [gridRef, setGridRef] = useState(null);
    const [filterDate, setFilterDate] = useState({});
    const [statesParent, setState] = useState({});
    const [ids, setId] = useState(0);

    const [showFactureModal, setShowFactureModal] = useState(false);
    const [showAddLiv, setShowAddLiv] = useState(false);
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [showFactureForm, setShowFactureForm] = useState(false);

    const gridStyle = { minHeight: window.screen.height - 200 };

    const filterValue = [
        { name: 'nomclient', operator: 'inlist', type: 'select', value: [] },
        { name: 'nofact', operator: 'contains', type: 'string', value: '' },
        { name: 'noprof', operator: 'contains', type: 'string', value: '' },
        { name: 'datefact', operator: 'inrange', type: 'date', value: null },
        { name: 'dateprof', operator: 'inrange', type: 'date', value: null },
        { name: 'username', operator: 'contains', type: 'string', value: '' },
        { name: 'userupdate', operator: 'contains', type: 'string', value: '' },
        { name: 'silivrer', operator: 'contains', type: 'string', value: '' }
    ];
    const column = [
        {
            name: 'id',
            header: 'Id',
            defaultVisible: false,
            defaultWidth: 80,
            type: 'number'
        },
        {
            header: 'Action',
            defaultWidth: 100,
            type: 'string',
            render: ({ value, data }) => (
                <ActionBtn
                    data={data}
                    handleShow={handleShow}
                    // EditFacture={EditFacture}
                    printFacture={printFacture}
                    setShowAddOrEdit={setShowAddOrEdit}
                    onDelete={onDelete}
                    // printBl={printBl}
                    // setShowAdds={setShowFactureForm}
                />
            )
        },
        { name: 'nofact', header: 'N° facture', defaultWidth: 90, type: 'string' },
        {
            name: 'datefact',
            header: 'Date facture',
            defaultWidth: 200,
            type: 'date',
            dateFormat: 'DD-MM-YYYY',
            textAlign: 'center',
            filterEditor: DateFilter,
            filterEditorProps: (props, { index }) => {
                // for range and notinrange operators, the index is 1 for the after field
                return {
                    dateFormat: 'DD-MM-YYYY',
                    placeholder: index === 1 ? 'Date fin' : 'Date début'
                };
            },
            render: ({ value, cellProps: { dateFormat } }) => (value ? moment(value).format(dateFormat) : 'Néant')
        },
        {
            name: 'silivrer',
            header: 'Statut',
            defaultWidth: 100,
            type: 'string',
            textAlign: 'center',
            render: ({ data }) => (
                <p id={data.silivrer === 'Livrer' ? 'successs' : 'success'}>
                    <OverlayTrigger
                        placement="right"
                        overlay={
                            <Tooltip id="tooltip-disabled">
                                {data.silivrer === 'Livrer' ? 'Facture déjà livrée' : 'Cliquer pour livrer'}
                            </Tooltip>
                        }
                    >
                        <a onClick={(e) => setShowAdds(data)}>{data.silivrer}</a>
                    </OverlayTrigger>
                </p>
            )
        },
        {
            name: 'nomclient',
            header: 'Clients',
            defaultWidth: 170,
            type: 'string',
            filterEditor: SelectFilter,
            filterEditorProps: {
                multiple: true,
                wrapMultiple: false,
                dataSource: clients.map((c) => {
                    return { id: c.raisonsocial, label: c.raisonsocial };
                })
            }
        },
        {
            // name: 'montantfacture',
            header: 'Remise',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[3] || 0)
        },
        {
            // name: 'montantfacture',
            header: 'Mont. HT',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[0] || 0)
        },
        {
            // name: 'montantfacture',
            header: 'Mont. TVA',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[1] || 0)
        },
        {
            // name: 'montantfacture',
            header: 'Mont. TTC',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[2] || 0)
        },
        {
            name: 'montantreglemnt',
            header: 'Mont. payé',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ value }) => common.numberformat(value)
        },
        {
            header: 'Reste à payé',
            defaultWidth: 90,
            textAlign: 'center',
            type: 'number',
            render: ({ data }) => common.numberformat(data.montantfacture[2] - data.montantreglemnt)
        },

        { name: 'noprof', header: 'N° proforma', defaultWidth: 90, type: 'string' },
        {
            name: 'dateprof',
            header: 'Date proforma',
            defaultWidth: 200,
            type: 'date',
            dateFormat: 'DD-MM-YYYY',
            textAlign: 'center',
            filterEditor: DateFilter,
            filterEditorProps: (props, { index }) => {
                return {
                    dateFormat: 'DD-MM-YYYY',
                    placeholder: index === 1 ? 'Date fin' : 'Date début'
                };
            },
            render: ({ value, cellProps: { dateFormat } }) => (value || value !== undefined ? moment(value).format(dateFormat) : 'Néant')
        },
        { name: 'username', header: 'Crée par', defaultWidth: 100, type: 'string' },
        {
            name: 'created_at',
            header: 'Crée le',
            defaultWidth: 130,
            type: 'string',
            render: ({ value }) => dateformater(value, 'dd-mm-yyyy HH:MM')
        },
        { name: 'userupdate', header: 'Modif. par', defaultWidth: 100, type: 'string' },
        {
            name: 'updated_at',
            header: 'Modif. le',
            defaultWidth: 130,
            type: 'string',
            render: ({ value }) => dateformater(value, 'dd-mm-yyyy HH:MM')
        }
    ];

    function setShowAdds(data) {
        setDatafacture(data);
        setShowAddLiv(true);
    }

    function setShowFilterModals(param) {
        setShowFilterModal(true);
    }
    const handleCloses = () => {
        setShowFilterModal(false);
    };
    function handleShow(d) {
        setDatafacture(d);
        setShowFactureModal(true);
    }

    function GetSortOrder(prop) {
        return function (a, b) {
            if (a[prop] > b[prop]) {
                return 1;
            } else if (a[prop] < b[prop]) {
                return -1;
            }
            return 0;
        };
    }

    // Supprimer une facture proforma
    async function onDelete(id, nofac) {
        const log = common.search(common.userdroit, 'SAD');
        const log1 = common.search(common.userdroit, 'SFAC');
        if (log == undefined) {
            if (log1 == undefined) {
                setMsg("Vous n'avez pas le droit d'effectuer cette action, merci de contacter l'administrateur");
                setMsgravity('danger');
                setIsSave(true);
                return;
            }
        }
        if (window.confirm('Voulez-vous supprimer cette ligne ?')) {
            setLoad(true);
            setIsLoad(true);

            await Axios.delete(common.ipapi + '/api/facture/destroy/' + id).then((response) => {
                if (response.data.status === 1) {
                    const del = rows.filter((d) => d.id != id);
                    setDataFact(del);

                    setMsg(response.data.msg);
                    setMsgravity('info');
                    setIsSave(true);
                    setLoad(false);
                    setIsLoad(false);
                } else {
                    setMsgravity('danger');
                    setMsg(response.data.msg);
                    setIsSave(true);
                    setLoad(false);
                    setIsLoad(false);
                }
            });
        }
    }

    function setShowAddOrEdit(id) {
        if (id) {
            Axios.get(common.ipapi + '/api/facture/edit/' + id)
                .then((response) => {
                    if (response.data) {
                        setState(response.data);
                        setId(id);
                        setShowFactureForm(true);
                    }
                    setLoad(false);
                })
                .catch((errors) => {
                    setLoad(false);
                });
        } else {
            setId(0);
            setState({});
            setShowFactureForm(true);
        }
    }

    //------- IMPRIMER FACTURE -----------------
    async function printFacture(id) {
        let text =
            'Voulez-vous imprimer avec ou sans entête ? \n Ok si vous voulez avec entête \n Annuler si vous ne voulez pas avec entête';
        let res = window.confirm(text);
        var doc = new jsPDF();
        var width = doc.internal.pageSize.getWidth();
        var dataFactures = [];
        var data = [];
        var resp = [];
        var i = 0;
        var h = 0;
        let mont = 0;
        let t = 0;
        let montht = 0;
        let montbrut = 0;
        let remis = 0;
        let remisChange = false;
        var siremise = false;
        let valremise = 0;
        setLoad(true);
        var type_remise = 0;
        var remise_main = 0;
        var val_remise = 0;
        await Axios.get(common.ipapi + '/api/facture/edit/' + id)
            .then((responses) => {
                resp = resp.concat(responses.data);

                responses.data.lignefacture.forEach((row) => {
                    h += row.pivot.prix * row.pivot.quantite;
                    type_remise = responses.data.type_remise;
                    remise_main = responses.data.remise_main;
                    if (row.pivot.remise != 0) {
                        siremise = true;
                    }
                    if (remise_main > 0) {
                        siremise = true;
                    }
                    valremise = responses.data.lignefacture[0].pivot.remise;
                    if (responses.data.lignefacture[0].pivot.remise != row.pivot.remise) {
                        remisChange = true;
                    }
                    var remisevalue =
                        responses.data.type_remise == 0 && responses.data.remise_main
                            ? row.pivot.prix * row.pivot.quantite * ((row.pivot.remise + responses.data.remise_main) / 100)
                            : row.pivot.prix * row.pivot.quantite * (row.pivot.remise / 100);
                    data.push({
                        descriptionart: row.pivot.descriptionart || row.descriptionartfr,
                        quantite: row.pivot.quantite,
                        prix: row.pivot.prix,
                        siremise: row.pivot.remise,
                        pourcentremise:
                            responses.data.client && responses.data.client.remise
                                ? responses.data.client.remise.pourcentage
                                : row.pivot.remise,
                        remis: remisevalue,
                        t: row.pivot.prix * row.pivot.quantite - remisevalue
                    });
                });
                data.forEach((row) => {
                    montbrut += row.t + row.remis;
                    montht += row.t;
                    remis += row.remis;
                    siremise
                        ? remisChange
                            ? dataFactures.push([
                                  { content: row.descriptionart },
                                  { content: row.quantite },
                                  { content: common.formatCurrency(row.prix) },
                                  { content: row.pourcentremise },
                                  { content: Math.round(row.remis) },
                                  { content: common.formatCurrency(row.t) }
                              ])
                            : dataFactures.push([
                                  { content: row.descriptionart },
                                  { content: row.quantite },
                                  { content: common.formatCurrency(row.prix) },
                                  { content: Math.round(row.remis) },
                                  { content: common.formatCurrency(row.t) }
                              ])
                        : dataFactures.push([
                              { content: row.descriptionart },
                              { content: row.quantite },
                              { content: common.formatCurrency(row.prix) },
                              { content: common.formatCurrency(row.t) }
                          ]);
                });
                val_remise = remise_main > 0 ? (type_remise == 0 ? 0 : remise_main) : 0;
                montht -= val_remise;
                responses.data.sitva == 1 ? (mont = montht) : (mont = montht + montht * 0.18);
                // console.log(remise_main);
            })
            .catch((errors) => {
                setLoad(false);
            });
        if (res === true) {
            doc.setFillColor(255, 127, 0);
            common.societe === 0 ? doc.addImage(common.logo, 'png', 14, 10, 30, 30) : doc.addImage(common.logo1, 'png', 14, 10, 30, 30);
            doc.setFontSize(16);
            doc.setFontSize(20);
            doc.setTextColor(0, 0, 0);
            doc.text('FACTURE CLIENT', 113, 26);
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.text(113, 43, 'Abidjan le: ' + dateformater(new Date(), 'dd/mm/yyyy'));
            doc.rect(110, 45, 86, 27);
            doc.text(resp[0].client ? 'Nom: ' + resp[0].client.raisonsocial : 'Nom: NEANT', 113, 50);
            doc.text(resp[0].client ? 'Télephone: ' + resp[0].client.telcli : 'Télephone: NEANT', 113, 55);
            doc.text('Compte contribuable: ' + resp[0].client.nocomptec, 113, 60);
            doc.text('N° facture: ' + resp[0].nofact, 113, 65);
            doc.text('Date pièce: ' + dateformater(resp[0].datefact, 'dd/mm/yyyy'), 113, 70);
            doc.text('Engin: ' + resp[0].engin, 15, 70);
            doc.setFontSize(10);
            if (remise_main > 0) {
                if (type_remise == 0) {
                    valremise = remise_main;
                }
            }
            doc.autoTable({
                styles: {
                    fillColor: [0, 0, 0],
                    textColor: [255, 255, 255],
                    lineColor: [0, 0, 0],
                    cellPadding: 1.25,
                    halign: 'center',
                    lineColor: [127, 143, 166]
                },
                columnStyles: siremise
                    ? remisChange
                        ? {
                              0: {
                                  halign: 'left',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              1: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              2: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              3: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              4: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              5: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              }
                          }
                        : {
                              0: {
                                  halign: 'left',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              1: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              2: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              3: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              4: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              }
                          }
                    : {
                          0: {
                              halign: 'left',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          3: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      },
                didDrawCell: function (data) {
                    h = data.cell.y + 20;
                },
                theme: 'grid',
                startY: 75,
                fontSize: 9,
                margin: { bottom: 40 },
                head: siremise
                    ? remisChange
                        ? [['Article', 'Quantité', 'Prix unit.', 'Remise(%)', 'Mont. remise', 'Montant']]
                        : [['Article', 'Quantité', 'Prix unit.', 'Remise(' + valremise + '%)', 'Montant']]
                    : [['Article', 'Quantité', 'Prix unit.', 'Montant']],
                body: dataFactures
                //foot: [['Montant TTC','','','','','',common.formatCurrency(mont+mont*0.18)]],
            });
            if (remise_main > 0) {
                if (type_remise == 0) {
                    // doc.text('Remimse ' + remise_main + '%', 15, doc.lastAutoTable.finalY + 4);
                } else {
                    doc.text('Remise ' + remise_main + ' FCFA', 15, doc.lastAutoTable.finalY + 4);
                }
            }
            doc.autoTable({
                styles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    cellPadding: 0.8,
                    lineColor: [0, 0, 0],
                    halign: 'center'
                },
                columnStyles: siremise
                    ? {
                          0: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          3: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          4: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      }
                    : {
                          0: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      },
                margin: { bottom: 40 },
                theme: 'grid',
                startY: doc.lastAutoTable.finalY + 9,
                head: siremise
                    ? [['TOTAL BRUT', 'REMISE', 'TOTAL NET', resp[0].sitva == 1 ? 'TVA EXONERE (18%)' : 'TVA (18%)', 'TOTAL TTC']]
                    : [['TOTAL NET', resp[0].sitva == 1 ? 'TVA  EXONERE (18%)' : 'TVA (18%)', 'TOTAL TTC']],
                body: siremise
                    ? [
                          [
                              common.formatCurrency(montbrut),
                              common.formatCurrency(remis + val_remise),
                              common.formatCurrency(montht),
                              common.formatCurrency(montht * 0.18),
                              common.formatCurrency(mont)
                          ]
                      ]
                    : [[common.formatCurrency(montht), common.formatCurrency(montht * 0.18), common.formatCurrency(mont)]]
            });
            var finalY = doc.lastAutoTable.finalY;
            if (finalY > 217) {
                doc.addPage();
            }
            const pageCount = doc.internal.getNumberOfPages();
            for (var u = 1; u <= pageCount; u++) {
                doc.setPage(u);
                doc.setFontSize(10);
                doc.text('Page ' + String(u) + ' sur ' + String(pageCount), 210 - 18, 292, null, null, 'right');
            }
            doc.text('Arrêté à la somme de:', 15, 229);
            doc.setFontSize(8);
            doc.text(NumberToLetter(Math.round(mont)).toUpperCase() + ' FCFA', 15, 236);
            doc.rect(14, 231, width - 28, 8);
            doc.setFontSize(10);
            doc.text('Visa direction:', 15, 246);
            // doc.rect(14, 247, 60, 22);
            doc.text('Visa client:', 135, 246);
            // doc.rect(135, 247, 60, 22);
            doc.setFontSize(8);

            doc.setLineWidth(1.5);
            doc.setFontSize(8);
            doc.setLineWidth(1.5);
            doc.setDrawColor(0, 0, 0);
            doc.line(0, 275, width, 275);
            doc.text(
                'Siège social - Marcory Boulevard de Marseille - Zone 4 - 26 BP 695 Abidjan 26 - Tel.: 27 21 36 39 79 / Fax: 27 21 34 59 59',
                105,
                280,
                null,
                'center'
            );
            doc.text(
                'RCCM N°CI-ABJ-2012-A-5995 - Compte SIB N° CI 007 0106885056950010020 / Cel: 07 08 29 40 40 /  Email: vicaso11@hotmail.fr ',
                105,
                285,
                null,
                'center'
            );
            doc.setFontSize(8);
            doc.setTextColor(254, 0, 0);
            // doc.text('* Aucun produit ne peut être retourner 15 jours après livraison', 14, doc.lastAutoTable.finalY + 3);
            doc.text('* Aucun produit ne peut être retourné', 14, doc.lastAutoTable.finalY + 3);

            setLoad(false);
            //doc.autoPrint({variant: 'non-conform'});
            doc.save('facture.pdf');
        } else {
            doc.setFillColor(255, 127, 0);
            doc.setFillColor(0, 0, 0);
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.text(119, 60, 'Abidjan le: ' + dateformater(new Date(), 'dd/mm/yyyy'));
            doc.rect(115, 61, 81, 27);
            doc.text(resp[0].client ? 'Nom: ' + resp[0].client.raisonsocial : 'Nom: NEANT', 119, 66);
            doc.text(resp[0].client ? 'Télephone: ' + resp[0].client.telcli : 'Télephone: NEANT', 119, 71);
            doc.text('Compte contribuable: ' + resp[0].client.nocomptec, 119, 76);
            doc.text('N° facture: ' + resp[0].noprof, 119, 81);
            doc.text('Date facture: ' + dateformater(resp[0].datefact, 'dd/mm/yyyy'), 119, 86);
            doc.text('Engin: ' + resp[0].engin, 15, 86);
            doc.setFontSize(10);

            doc.autoTable({
                styles: {
                    fillColor: [0, 0, 0],
                    textColor: [255, 255, 255],
                    lineColor: [0, 0, 0],
                    cellPadding: 1.25,
                    halign: 'center'
                },
                columnStyles: siremise
                    ? remisChange
                        ? {
                              0: {
                                  halign: 'left',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              1: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              2: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              3: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              4: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              5: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              }
                          }
                        : {
                              0: {
                                  halign: 'left',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              1: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              2: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              3: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              },
                              4: {
                                  halign: 'center',
                                  fillColor: [255, 255, 255],
                                  textColor: [0, 0, 0],
                                  cellPadding: 0.75,
                                  fontSize: 10
                              }
                          }
                    : {
                          0: {
                              halign: 'left',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          3: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      },
                didDrawCell: function (data) {
                    h = data.cell.y + 20;
                },
                theme: 'grid',
                startY: 90,
                fontSize: 9,
                margin: { bottom: 40 },
                head: siremise
                    ? remisChange
                        ? [['Article', 'Quantité', 'Prix unit.', 'Remise(%)', 'Mont. remise', 'Montant']]
                        : [['Article', 'Quantité', 'Prix unit.', 'Remise(' + valremise + '%)', 'Montant']]
                    : [['Article', 'Quantité', 'Prix unit.', 'Montant']],
                body: dataFactures
            });
            if (remise_main > 0) {
                if (type_remise == 0) {
                    doc.text('Remise ' + remise_main + '%', 15, doc.lastAutoTable.finalY + 4);
                } else {
                    doc.text('Remise ' + remise_main + ' FCFA', 15, doc.lastAutoTable.finalY + 4);
                }
            }
            doc.autoTable({
                styles: {
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    cellPadding: 0.8,
                    lineColor: [0, 0, 0],
                    halign: 'center'
                },
                columnStyles: siremise
                    ? {
                          0: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          3: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          4: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      }
                    : {
                          0: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          1: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          },
                          2: {
                              halign: 'center',
                              fillColor: [255, 255, 255],
                              textColor: [0, 0, 0],
                              cellPadding: 0.75,
                              fontSize: 10
                          }
                      },
                margin: { bottom: 35 },
                theme: 'grid',
                startY: doc.lastAutoTable.finalY + 9,
                head: siremise
                    ? [['TOTAL BRUT', 'REMISE', 'TOTAL NET', resp[0].sitva == 1 ? 'TVA EXONERE (18%)' : 'TVA (18%)', 'TOTAL TTC']]
                    : [['TOTAL NET', resp[0].sitva == 1 ? 'TVA  EXONERE (18%)' : 'TVA (18%)', 'TOTAL TTC']],
                body: siremise
                    ? [
                          [
                              common.formatCurrency(montbrut),
                              common.formatCurrency(remis + val_remise),
                              common.formatCurrency(montht),
                              common.formatCurrency(montht * 0.18),
                              common.formatCurrency(mont)
                          ]
                      ]
                    : [[common.formatCurrency(montht), common.formatCurrency(montht * 0.18), common.formatCurrency(mont)]]
            });

            var finalY = doc.lastAutoTable.finalY;
            if (finalY > 217) {
                doc.addPage();
            }
            const pageCount = doc.internal.getNumberOfPages();
            for (var u = 1; u <= pageCount; u++) {
                doc.setPage(u);
                doc.setFontSize(10);
                doc.text('Page ' + String(u) + ' sur ' + String(pageCount), 210 - 18, 292, null, null, 'right');
            }
            doc.text('Arrêté à la somme de:', 15, 229);
            doc.setFontSize(8);
            doc.text(NumberToLetter(Math.round(mont)).toUpperCase() + ' FCFA', 15, 236);
            doc.rect(14, 231, width - 28, 8);
            doc.setFontSize(10);
            doc.text('Visa direction:', 15, 246);
            doc.text('Visa client:', 135, 246);
            doc.setFontSize(8);
            doc.setLineWidth(1.5);
            setLoad(false);
            doc.setFontSize(8);
            doc.setTextColor(254, 0, 0);
            // doc.text('* Aucun produit ne peut être retourner 15 jours après livraison', 14, doc.lastAutoTable.finalY + 3);
            doc.text('* Aucun produit ne peut être retourné', 14, doc.lastAutoTable.finalY + 3);

            //doc.autoPrint({variant: 'non-conform'});
            doc.save('facture.pdf');
        }
    }

    
    const exportCSV = async () => {
            //--------------- EXPORT VERS EXCEL ------------------
            const raw_data = gridRef.current.data.sort(GetSortOrder('datefact'));
            if (raw_data.length <= 0) {
                setMsg('Aucune donnée à exporter');
                setIsSave(true);
                setMsgravity('danger');
                return;
            }
            const debutFormate = dateformater(raw_data[0].datefact, 'yyyy-mm-dd');
            const finFormatee = dateformater(raw_data[raw_data.length - 1].datefact, 'yyyy-mm-dd');
            const listeFacturesAvoirs = await getFactureAvoir(debutFormate, finFormatee);

            const rows = [];
            var realqte = 0;
            var qteprix = 0;
            raw_data.map((row, index) => {
                const totalBrut = row.lignefacture.reduce((acc, item) => acc + (item.pivot.prix * item.pivot.quantite), 0);
                row.lignefacture.map((lsort) => {
                    var prixachat = lsort.pivot.prix_achat;
    
                    realqte = lsort.pivot.quantite;
                    qteprix = lsort.pivot.prix * realqte;
                    var remise = qteprix * (lsort.pivot.remise / 100);

                    let remiseFixe = 0;
    
                    if (row.remise_main > 0) {
                        if (row.type_remise == 0) {
                            remiseFixe = qteprix * (row.remise_main / 100);
                        } else if (row.type_remise == 1) {
                            if (row.lignefacture.length === 1) {
                                remiseFixe = row.remise_main;
                            } else {
                                // const totalBrut = row.prix_ttc + row.remise;
                                remiseFixe = totalBrut > 0 ? (qteprix / totalBrut) * row.remise_main : 0;
                            }
                        }
                    }
                    let prixremiser = qteprix - remise - remiseFixe;
    
                    rows.push({
                        numbon: row.nofact,
                        client: row.nomclient,
                        qrbarre: lsort.qrbarre,
                        description: lsort.descriptionart,
                        engin: lsort.famille ? lsort.famille.libellefam + ' / ' + row.engin : row.engin,
                        retour: realqte,
                        prixachat: common.societe < 2 ? prixachat : 0,
                        tachat: common.societe < 2 ? Math.round(prixachat * realqte) : 0, 
                        remise: remise + remiseFixe, 
                        prixvente: lsort.pivot.prix,
                        tvente: qteprix, 
                        prixremiser: prixremiser, 
                        tva: row.sitva == 1 ? 0 : prixremiser * 0.18, 
                        benefice: common.societe < 2 ? prixremiser - (realqte * prixachat) : 0,
                        date: dateformater(row.datesort, 'dd-mm-yyyy')
                    });
                });
            });

            //--------------- LES FACTURES D'AVOIR (structure différente) ------------------
            // Une facture d'avoir annule une partie de la vente : les montants et les
            // quantités sont donc exportés en négatif pour venir en déduction des factures.
            const avoirs = Array.isArray(listeFacturesAvoirs) ? listeFacturesAvoirs.sort(GetSortOrder('date_avoir')) : [];
            avoirs.map((avoir) => {
                const lignes = avoir.ligneavoir || [];
                lignes.map((ligne) => {
                    // ligne.montant_avoir = prix unitaire, le total ligne = montant * qté
                    const qte = ligne.qte_avoir || 0;
                    const prixUnitaire = ligne.montant_avoir || 0;
                    const totalLigne = -(prixUnitaire * qte);

                    rows.push({
                        numbon: avoir.numero_avoir,
                        client: avoir.client,
                        qrbarre: '',
                        description: ligne.libelle_avoir,
                        engin: 'AVOIR / Fact. ' + (avoir.nofact || ''),
                        retour: -qte,
                        prixachat: prixUnitaire,
                        tachat: totalLigne,
                        remise: 0,
                        prixvente: prixUnitaire,
                        tvente: totalLigne,
                        prixremiser: totalLigne,
                        tva: avoir.sitva == 1 ? 0 : totalLigne * 0.18,
                        benefice: 0,
                        date: dateformater(avoir.date_avoir, 'dd-mm-yyyy')
                    });
                });
            });

            /* generate worksheet and workbook */
            const worksheet = XLSX.utils.json_to_sheet(rows);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Mes factures');
            /* fix headers */
            XLSX.utils.sheet_add_aoa(
                worksheet,
                [['N° facture','Clients','Code','Articles', 'Engin','Qté','Prix achat','Total achat','Remise','Prix vente','Total vente','Total remisé','TVA','Benefice','Date fact.']],
                { origin: 'A1'}
            );
            /* calculate column width */
            const max_width = rows.reduce((w, r) => Math.max(w, String(r.numbon || '').length), 10);
            worksheet['!cols'] = [{ wch: max_width }];
            XLSX.writeFile(workbook, 'facture.xlsx');
    };

    

    const exportCSVModel = async () => {
        //--------------- EXPORT VERS EXCEL ------------------
        const raw_data = gridRef.current.data.sort(GetSortOrder('datesort'));
        /* flatten objects */

        const rows = [];
        var realqte = 0;
        var qteprix = 0;
        raw_data.map((row, index) => {
            row.lignefacture.map((lsort) => {
                // realqte = lsort.pivot.quantite - lsort.pivot.quantiteretour;
                // let prixachat = lsort.pivot.prix_achat;
                var prixachat = lsort.pivot.prix_achat !== 0 ? lsort.pivot.prix_achat : lsort.prixachat;

                realqte = lsort.pivot.quantite - lsort.pivot.quantiteretour;
                qteprix = lsort.pivot.prix * realqte;
                var remise = qteprix * (lsort.pivot.remise / 100);
                remise += row.remise_main > 0 ? (row.type_remise > 0 ? row.remise_main : (qteprix - remise) * (row.remise_main / 100)) : 0;

                
                let remiseFixe = 0;

                if (row.remise_main > 0) {
                    if (row.type_remise == 0) {
                        // Cas 1 : Remise en % (row.remise_main vaut par exemple 5 pour 5%)
                        remiseFixe = qteprix * (row.remise_main / 100);
                    } else if (row.type_remise == 1) {
                        // Cas 2 : Remise en montant fixe répartie au prorata de la valeur de la ligne
                        if (row.lignesort.length === 1) {
                            remiseFixe = row.remise_main;
                        } else {
                            // Prorata : (Valeur Ligne / Valeur Totale Brute) * Montant Remise Globale
                            // Note : row.prix_ttc + row.remise représente bien le total brut avant remise
                            const totalBrut = row.prix_ttc + row.remise;
                            remiseFixe = totalBrut > 0 ? (qteprix / totalBrut) * row.remise_main : 0;
                        }
                    }
                }
                let prixremiser = qteprix - remise - remiseFixe;
                rows.push({
                    numbon: row.numbon,
                    client: row.client,
                    qrbarre: lsort.qrbarre,
                    description: lsort.descriptionart,
                    engin: lsort.famille ? lsort.famille.libellefam + ' / ' + row.engin : row.engin,
                    retour: realqte,
                    prixachat: common.societe < 2 ? prixachat : 0,
                    tachat: common.societe < 2 ? prixachat * realqte : 0, //
                    remise: remise+remiseFixe, //
                    prixvente: lsort.pivot.prix,
                    tvente: qteprix, //
                    prixremiser: prixremiser, //
                    tva: row.sitva == 1 ? 0 : prixremiser * 0.18, //
                    benefice: qteprix - remise - remiseFixe - realqte * prixachat,
                    date: dateformater(row.datesort, 'dd-mm-yyyy')
                });
            });
        });

        /* generate worksheet and workbook */
        const worksheet = XLSX.utils.json_to_sheet(rows);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Mes sorties');
        /* fix headers */
        XLSX.utils.sheet_add_aoa(
            worksheet,
            [
                [
                    'N° bon',
                    'Clients',
                    'Code',
                    'Articles',
                    'Engin',
                    'Qté',
                    'Prix achat',
                    'Total achat',
                    'Remise',
                    'Prix vente U',
                    'Prix vente',
                    'Total remisé',
                    'TVA',
                    'Benefice',
                    'Date sortie'
                ]
            ],
            {
                origin: 'A1'
            }
        );
        /* calculate column width */
        const max_width = rows.reduce((w, r) => Math.max(w, r.numbon.length), 10);
        worksheet['!cols'] = [{ wch: max_width }];
        XLSX.writeFile(workbook, 'sortie.xlsx');
    };

    // async function getFactureAvoir(debut, fin) {
    //     const log = common.search(common.userdroit, 'SAD');
    //     const log1 = common.search(common.userdroit, 'FAC');
    //     if (log === undefined) {
    //         if (log1 === undefined) {
    //             return;
    //         }
    //     }
    //     setLoad(true);
    //     setIsLoad(true);
    //     await Axios.get(common.ipapi + '/api/avoir/filterplus/' + debut + '/' + fin + '/' + common.societe, common.tok)
    //         .then((response) => {
    //             setLoad(false);
    //             setIsLoad(false);
    //             return response.data.datas;
    //         })
    //         .catch((errors) => {
    //             setLoad(false);
    //             setIsLoad(false);
    //         });
    // }

    // La fonction reste asynchrone pour utiliser await
    async function getFactureAvoir(dateDebut, dateFin) {
        const aLeDroitSAD = common.search(common.userdroit, 'SAD') !== undefined;
        const aLeDroitFAC = common.search(common.userdroit, 'FAC') !== undefined;

        if (!aLeDroitSAD && !aLeDroitFAC) {
            return;
        }

        setLoad(true);
        setIsLoad(true);

        try {
            const url = `${common.ipapi}/api/avoir/filterplus/${dateDebut}/${dateFin}/${common.societe}`;
            const response = await Axios.get(url, common.tok);
            return response.data.datas;
        } catch (error) {
            console.error('Erreur lors de la récupération des factures/avoirs:', error);
            return null;
        } finally {
            setLoad(false);
            setIsLoad(false);
        }
    }

    //-------------IMPRIMER LES LISTE ----------------
    function printListeSelect() {
        if (window.confirm('Voulez-vous la version détaillée ?') === true) {
            printListeDetail();
        } else {
            printListe();
        }
    }
    function printListe() {
        if (gridRef.current.data.length <= 0) {
            setMsg('Aucune donnée à imprimer');
            setIsSave(true);
            setMsgravity('danger');
            return;
        }
        const doc = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: 'a4',
            putOnlyUsedFonts: true
        });
        var width = doc.internal.pageSize.getWidth();
        const data = [];
        let mont = 0;
        let reglement = 0;
        let reste = 0;
        let totalTva = 0;
        let totalRemise = 0;

        // common.ipapi == 'https://192.168.8.109:81' || common.ipapi == 'https://api.tracky-entrepot.com'
        //     ? doc.addImage(common.logo, 'png', 14, 10, 30, 30)
        //     : doc.addImage(common.logo1, 'png', 14, 10, 30, 30);
        doc.setFontSize(16);
        common.ipapi == 'https://192.168.8.109:81' || common.ipapi == 'https://api.tracky-entrepot.com'
            ? doc.text('DEPOT', 90, 14)
            : doc.text('HR MOTORS', 90, 14);
        doc.setFontSize(12);
        doc.setFillColor(0, 0, 0);
        doc.rect(65, 15, width - 80, 10, 'F');
        doc.setTextColor(255, 255, 255);
        doc.text('LISTE DES FACTURES CLIENTS', 90, 22);

        doc.setFontSize(12);
        doc.setTextColor(0, 0, 0);
        console.log(gridRef.current.data);
        // doc.text("Période du: "+dateformater(datedeb || gridRef.current.data[gridRef.current.data.length-1].datesort,"dd-mm-yyyy")+" Au : "+dateformater(datefin || gridRef.current.data[0].datesort,"dd-mm-yyyy") ,65,32)
        gridRef.current.data.forEach((row) => {
            mont += row.montantfacture[2];
            reglement += row.montantreglemnt;
            reste += row.montantfacture[2] - row.montantreglemnt;
            totalTva += row.montantfacture[1];
            totalRemise += row.montantfacture[3];
            data.push([
                { content: row.nomclient },
                { content: row.nofact !== null ? row.nofact : '' },
                { content: row.datefact !== null ? dateformater(row.datefact, 'dd-mm-yyyy') : '' },
                { content: row.noprof ? row.noprof : '' },
                { content: dateformater(row.dateprof, 'dd-mm-yyyy') },
                { content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(row.montantfacture[0]) },
                { content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(row.montantfacture[1]) },
                { content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(row.montantfacture[2]) },
                { content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(row.montantfacture[3]) },
                { content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(row.montantfacture[2]-row.montantfacture[3]) },

                {
                    content: new Intl.NumberFormat('de-DE', {
                        style: 'decimal',
                        currency: 'CFA'
                    }).format(row.montantreglemnt)
                },

                {
                    content: new Intl.NumberFormat('de-DE', {
                        style: 'decimal',
                        currency: 'CFA'
                    }).format(row.montantfacture[2] - row.montantreglemnt)
                }
            ]);
        });
        data.push([
            { content: 'TOTAL GENERAL', colSpan: 6, styles: { fontStyle: 'bold', fontSize: 12 } },
            {
                content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(totalTva),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },

            {
                content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(mont),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            {
                content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(totalRemise),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            {
                content: new Intl.NumberFormat('de-DE', { style: 'decimal', currency: 'CFA' }).format(mont+totalTva-totalRemise),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            {
                content: new Intl.NumberFormat('de-DE', {
                    style: 'decimal',
                    currency: 'CFA'
                }).format(reglement),
                styles: { fontStyle: 'bold', fontSize: 12 }
            },
            {
                content: new Intl.NumberFormat('de-DE', {
                    style: 'decimal',
                    currency: 'CFA'
                }).format(reste),
                styles: { fontStyle: 'bold', fontSize: 12 }
            }
        ]);
        doc.autoTable({
            styles: {
                fillColor: [169, 234, 254],
                textColor: [0, 0, 0],
                halign: 'center',
                fontSize: 10,
                cellPadding: 0.75
            },
            columnStyles: {
                0: {
                    halign: 'left',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                1: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                2: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                3: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                4: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                5: {
                    halign: 'center',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                6: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                7: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                8: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                9: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                10: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                11: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                },
                12: {
                    halign: 'right',
                    fillColor: [255, 255, 255],
                    textColor: [0, 0, 0],
                    fontSize: 8
                }
            },
            theme: 'grid',
            startY: 35,
            fontSize: 6,
            head: [
                [
                    'Clients',
                    'N° facture',
                    'Date facture',
                    'N° proforma',
                    'Date proforma',
                    'Montant HT',
                    'Montant TVA',
                    'Montant TTC',
                    'Remise',
                    'Total remisé',
                    'Montant reglé',
                    'Reste'
                ]
            ],
            body: data
        });
        const pageCount = doc.internal.getNumberOfPages();
        for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text('Page ' + String(i) + ' sur ' + String(pageCount), 210 - 55, 200, null, null, 'right');
        }
        doc.setFontSize(8);
        doc.setTextColor(254, 0, 0);
        // doc.text('* Aucun produit ne peut être retourné 15 jours après livraison', 14, doc.lastAutoTable.finalY + 3);
        doc.text('* Aucun produit ne peut être retourné', 14, doc.lastAutoTable.finalY + 3);

        doc.save('liste facture.pdf');
    }

    async function printListeDetail() {
        if (!gridRef.current?.data || gridRef.current.data.length <= 0) {
            return;
        }

        const doc = new jsPDF({
            orientation: 'l',
            unit: 'mm',
            format: 'a4',
            putOnlyUsedFonts: true
        });
        
        const width = doc.internal.pageSize.getWidth();
        const data = [];
        const listeAvoirs = [];
        
        let remiseCumul = 0;
        let totalachat = 0;
        let mont = 0;
        let qte = 0;
        let benefice = 0;
        let totalremiser = 0;
        let TotalHt = 0;
        let tvaremise = 0;
        let totalTva = 0;
        let totalRemise = 0;

        // Fonction locale pour formater rapidement les nombres sans instancier Intl à chaque cellule
        const formatter = new Intl.NumberFormat(['ban', 'id']);
        const formatNumber = (num) => formatter.format(Math.round(num)).replace('.', ' ');

        common.societe === 0 ? doc.addImage(common.logo, 'png', 14, 10, 30, 30) : doc.addImage(common.logo1, 'png', 14, 10, 30, 30);
        
        doc.setFillColor(61, 43, 31);
        doc.rect(65, 15, width - 80, 10, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(12);
        doc.text('LISTE DES FACTURES AVEC DETAILS', 90, 22);
        doc.setTextColor(0, 0, 0);

        // Tri des données par date
        const datavar = [...gridRef.current.data].sort(GetSortOrder('datefact'));

        const datedeb = dateformater(datavar[0].datefact, 'dd-mm-yyyy');
        const datefin = dateformater(datavar[datavar.length - 1].datefact, 'dd-mm-yyyy');
        const debutFormate = dateformater(datavar[0].datefact, 'yyyy-mm-dd');
        const finFormatee = dateformater(datavar[datavar.length - 1].datefact, 'yyyy-mm-dd');

        const listeFacturesAvoirs = await getFactureAvoir(debutFormate, finFormatee);

        if (listeFacturesAvoirs) {
            let totalAvoirTTC = 0;
            let totalAvoirHT = 0;
            let totalAvoirTVA = 0;
            let totalAvoirQTE = 0;

            listeFacturesAvoirs.forEach((avoir) => {
                avoir.ligneavoir.forEach((lavoir) => {
                    listeAvoirs.push([
                        {
                            content: `Avoir N°: ${avoir.numero_avoir} / Date: ${dateformater(avoir.date_avoir, 'dd-mm-yyyy')} / Client: ${avoir.client} / Facture N°: ${avoir.nofact}`,
                            colSpan: 5,
                            styles: { fontStyle: 'bold', fontSize: '8' }
                        }
                    ]);

                    const tva = avoir.sitva == 0 ? lavoir.montant_avoir * lavoir.qte_avoir * 0.18 : 0;
                    totalAvoirHT += lavoir.montant_avoir * lavoir.qte_avoir;
                    totalAvoirTVA += tva;
                    totalAvoirTTC += (lavoir.montant_avoir * lavoir.qte_avoir) + tva;
                    totalAvoirQTE += lavoir.qte_avoir;

                    listeAvoirs.push([
                        lavoir.libelle_avoir,
                        formatNumber(lavoir.qte_avoir),
                        formatNumber(lavoir.montant_avoir),
                        formatNumber(lavoir.montant_avoir * lavoir.qte_avoir),
                        formatNumber(tva),
                        formatNumber(lavoir.montant_avoir + tva)
                    ]);
                });
            });

            listeAvoirs.push([
                { content: 'TOTAL', colSpan: 1, styles: { fontStyle: 'bold', fontSize: 12 } },
                { content: formatNumber(totalAvoirQTE), styles: { fontStyle: 'bold', fontSize: 12 } },
                { content: '' },
                { content: formatNumber(totalAvoirHT), styles: { fontStyle: 'bold', fontSize: 12 } },
                { content: formatNumber(totalAvoirTVA), styles: { fontStyle: 'bold', fontSize: 12 } },
                { content: formatNumber(totalAvoirTTC), styles: { fontStyle: 'bold', fontSize: 12 } }
            ]);
        }

        datavar.forEach((row, index) => {
            // En-tête de regroupement par facture
            if (index === 0 || row.nofact !== datavar[index - 1].nofact) {
                data.push([
                    {
                        content: `Client: ${row.nomclient} / facture N°: ${row.nofact} / Date: ${dateformater(row.datefact, 'dd-mm-yyyy')}`,
                        colSpan: 11,
                        styles: { fontStyle: 'bold', fontSize: '8', fillColor: [240, 240, 240] }
                    }
                ]);
            }
            
            totalTva += row.montantfacture[1];
            totalRemise += row.montantfacture[3];
            TotalHt += row.montantfacture[0];
            const totalBrut = row.lignefacture.reduce((acc, item) => acc + (item.pivot.prix * item.pivot.quantite), 0);
            row.lignefacture.forEach((lsort) => {
                const prixachat = lsort.pivot.prix_achat;
                const realqte = lsort.pivot.quantite;
                const qteprix = lsort.pivot.prix * realqte;
                
                // Logique de calcul de la remise globale (remise_main) répartie sur la ligne
                let remiseFixe = 0;
                if (row.remise_main > 0) {
                    if (row.type_remise == 0) {
                        remiseFixe = qteprix * (row.remise_main / 100);
                    } else if (row.type_remise == 1) {
                        if (row.lignefacture.length === 1) {
                            remiseFixe = row.remise_main;
                        } else {
                            // const totalBrut = row.prix_ttc + row.remise;
                            remiseFixe = totalBrut > 0 ? (qteprix / totalBrut) * row.remise_main : 0;
                        }
                    }
                }

                mont += qteprix;
                qte += realqte;
                
                const remiseLigne = qteprix * (lsort.pivot.remise / 100);
                remiseCumul += remiseLigne + remiseFixe;
                benefice += qteprix - (realqte * prixachat) - remiseLigne - remiseFixe;
                const prixremiser = qteprix - remiseLigne - remiseFixe;
                totalremiser += prixremiser;
                totalachat += prixachat * realqte;


                data.push([
                    lsort.qrbarre,
                    lsort.descriptionart,
                    formatNumber(realqte),
                    formatNumber(prixachat),
                    formatNumber(prixachat * realqte),
                    formatNumber(remiseLigne + remiseFixe),
                    formatNumber(lsort.pivot.prix),
                    formatNumber(qteprix),
                    formatNumber(prixremiser),
                    formatNumber(row.sitva == 1 ? 0 : prixremiser * 0.18),
                    formatNumber(qteprix - remiseLigne- remiseFixe - (realqte * prixachat))
                ]);
            });

            if (row.remise_main > 0) {
                tvaremise += row.type_remise > 0
                    ? row.remise_main * 0.18
                    : (mont - remiseCumul) * (row.remise_main / 100) * 0.18;
            }
        });

        // Gestion de l'affichage de la période filtrée
        let textePeriode = `Période du: ${datedeb} Au : ${datefin}`;
        if (filterDate && Object.keys(filterDate).length > 0) {
            const start = filterDate.start || datedeb;
            const end = filterDate.end || datefin;
            textePeriode = `Période du: ${start} Au : ${end}`;
        }
        doc.text(textePeriode, 65, 32);
        const totalRowStyles = { fontStyle: 'bold', fontSize: 10, fillColor: [220, 245, 255], textColor: [0, 0, 0] };
        // Ligne des TOTAUX Généraux Factures
        data.push([
            { content: 'TOTAL', styles: totalRowStyles },
            '',
            { content: formatNumber(qte), styles: totalRowStyles },
            '',
            { content: formatNumber(totalachat), styles: totalRowStyles },
            { content: formatNumber(remiseCumul), styles: totalRowStyles },
            '',
            { content: formatNumber(totalremiser + remiseCumul), styles: totalRowStyles },
            { content: formatNumber(totalremiser), styles: totalRowStyles },
            { content: formatNumber(totalTva), styles: totalRowStyles },
            { content: formatNumber(totalremiser - totalachat), styles: totalRowStyles }
        ]);

        // Génération de la table des Factures
        doc.autoTable({
            styles: { fillColor: [169, 234, 254], textColor: [4, 4, 4], halign: 'center', fontSize: 10, cellPadding: 0.75 },
            columnStyles: {
                0: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 },
                1: { halign: 'left', fillColor: [255, 255, 255], fontSize: 8 },
                2: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 },
                3: { halign: 'left', fillColor: [255, 255, 255], fontSize: 8 },
                4: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 },
                5: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 },
                6: { halign: 'right', fillColor: [255, 255, 255], fontSize: 8 },
                7: { halign: 'right', fillColor: [255, 255, 255], fontSize: 8 },
                8: { halign: 'right', fillColor: [255, 255, 255], fontSize: 8 },
                9: { halign: 'right', fillColor: [255, 255, 255], fontSize: 8 },
                10: { halign: 'right', fillColor: [255, 255, 255], fontSize: 8 }
            },
            theme: 'grid',
            startY: 35,
            head: [['Code', 'Articles', 'Qté liv', 'Prix achat', 'Total achat', 'Remise', 'Prix vente', 'Total vente', 'Total remisé', 'TVA', 'Bénéfice']],
            body: data
        });

        // Génération de la table des Avoirs (si existants)
        if (listeFacturesAvoirs && listeFacturesAvoirs.length > 0) {
            doc.setFillColor(169, 234, 254);
            doc.rect(14, doc.lastAutoTable.finalY + 5, width - 29, 7, 'F');
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(12);
            doc.text('DETAILS DES AVOIRS', 90, doc.lastAutoTable.finalY + 10);

            doc.autoTable({
                styles: { fillColor: [169, 234, 254], textColor: [4, 4, 4], halign: 'center', fontSize: 10, cellPadding: 0.75 },
                columnStyles: {
                    0: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 },
                    1: { halign: 'left', fillColor: [255, 255, 255], fontSize: 8 },
                    2: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 },
                    3: { halign: 'left', fillColor: [255, 255, 255], fontSize: 8 },
                    4: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 },
                    5: { halign: 'center', fillColor: [255, 255, 255], fontSize: 8 }
                },
                theme: 'grid',
                startY: doc.lastAutoTable.finalY + 13,
                head: [['Désignation', 'Quantité', 'Montant', 'Total HT', 'Total TVA', 'Total TTC']],
                body: listeAvoirs
            });

            // Récapitulatif Général combiné (Factures - Avoirs)
            doc.setFillColor(169, 234, 254);
            doc.rect(14, doc.lastAutoTable.finalY + 10, width - 29, 7, 'F');
            doc.setTextColor(0, 0, 0);
            doc.text('RECAPITULATIF GENERAL', 90, doc.lastAutoTable.finalY + 15);
            
            const totalAvoirQTE = listeAvoirs.length > 0 ? listeAvoirs[listeAvoirs.length - 1][1].content : 0; 
            // Note: Pour être précis et dynamique, reprenons directement les variables de portée supérieure calculées plus haut
            const tAvoirQTE = listeFacturesAvoirs.reduce((acc, av) => acc + av.ligneavoir.reduce((sub, l) => sub + l.qte_avoir, 0), 0);
            const tAvoirHT = listeFacturesAvoirs.reduce((acc, av) => acc + av.ligneavoir.reduce((sub, l) => sub + (l.montant_avoir * l.qte_avoir), 0), 0);
            const tAvoirTVA = listeFacturesAvoirs.reduce((acc, av) => acc + av.ligneavoir.reduce((sub, l) => sub + (av.sitva == 0 ? l.montant_avoir * l.qte_avoir * 0.18 : 0), 0), 0);
            const tAvoirTTC = tAvoirHT + tAvoirTVA;

            doc.autoTable({
                styles: { fillColor: [169, 234, 254], textColor: [0, 0, 0], halign: 'center', fontSize: 10, cellPadding: 0.75 },
                columnStyles: {
                    0: { halign: 'center', fillColor: [61, 43, 31], textColor: [255, 255, 255], fontSize: 8 },
                    1: { halign: 'center', fillColor: [61, 43, 31], textColor: [255, 255, 255], fontSize: 8 },
                    2: { halign: 'center', fillColor: [61, 43, 31], textColor: [255, 255, 255], fontSize: 8 },
                    3: { halign: 'center', fillColor: [61, 43, 31], textColor: [255, 255, 255], fontSize: 8 }
                },
                theme: 'grid',
                startY: doc.lastAutoTable.finalY + 18,
                head: [['Quantités Général', 'Total G HT', 'Total G TVA', 'Total G TTC']],
                body: [
                    [
                        { content: formatNumber(qte - tAvoirQTE), styles: totalRowStyles },
                        { content: formatNumber(TotalHt - tAvoirHT), styles: totalRowStyles },
                        { content: formatNumber(totalTva - tAvoirTVA), styles: totalRowStyles },
                        { content: formatNumber((TotalHt + totalTva) - tAvoirTTC), styles: totalRowStyles }
                    ]
                ]
            });
        }

        // Numérotation des pages du PDF
        const pageCount = doc.internal.getNumberOfPages();
        for (let u = 1; u <= pageCount; u++) {
            doc.setPage(u);
            doc.setFontSize(10);
            doc.text(`Page ${u} sur ${pageCount}`, width - 25, 200, null, null, 'right');
        }
        
        doc.save('Listefacture.pdf');
    }

    return (
        <div>
            {showAddLiv ? (
                <AddSortie
                    setShowAddLiv={setShowAddLiv}
                    show={showAddLiv}
                    setIsSave={setIsSave}
                    setMsg={setMsg}
                    setMsgravity={setMsgravity}
                    data={datafacture}
                    getProforma={getProforma}
                    getFacture={getFacture}
                    keys={keys}
                />
            ) : (
                <></>
            )}
            {showFactureForm ? (
                <AddFacture
                    setShowAdd={setShowFactureForm}
                    show={showFactureForm}
                    setIsSave={setIsSave}
                    // isSave={isSave}
                    setMsg={setMsg}
                    setMsgravity={setMsgravity}
                    setActualise={setActualise}
                    actualise={actualise}
                    ids={ids}
                    statesParent={statesParent}
                    source="facturey"
                />
            ) : (
                <></>
            )}
            {showDetailFactureModal ? (
                <ShowFacture
                    factureDetail={factureDetail}
                    showDetailFactureModal={showDetailFactureModal}
                    handleClose={handleClose}
                    keys={keys}
                />
            ) : (
                <></>
            )}

            {showFilterModal ? (
                <FilterModale
                    setShowFilterModals={setShowFilterModals}
                    showFilterModal={showFilterModal}
                    keys={keys}
                    setMsg={setMsg}
                    setIsSave={setIsSave}
                    setMsgravity={setMsgravity}
                    setLoad={setLoad}
                    load={load}
                    handleClose={handleCloses}
                    setDatasProf={setDataFact}
                    paramShow={paramShow}
                    setDataFact={setDataFact}
                />
            ) : (
                <></>
            )}
            {showFactureModal ? (
                <FacturerModal
                    show={showFactureModal}
                    setShowFactureModal={setShowFactureModal}
                    getFacture={getFacture}
                    getProforma={getProforma}
                    datafacture={datafacture}
                    setMsg={setMsg}
                    setMsgravity={setMsgravity}
                    setIsSave={setIsSave}
                    setLoad={setLoad}
                />
            ) : (
                <></>
            )}
            <NavMenu
                printListe={printListeSelect}
                selected={selected}
                setShowAddOrEdit={setShowAddOrEdit}
                exportCSV={exportCSV}
                setShowFilterModals={setShowFilterModals}
            />
            <ReactDataGrid
                idProperty="id"
                handle={setGridRef}
                style={gridStyle}
                loading={isLoading}
                reorderColumns={false}
                pagination
                selected={selected}
                // checkboxColumn
                // onSelectionChange={onSelectionChange}
                pageSizes={[200, 400, 600, 800, rows.length]}
                defaultLimit={400}
                showHoverRows={true}
                editable={true}
                showColumnMenuTool={false}
                defaultFilterValue={filterValue}
                columns={column}
                dataSource={rows}
            />
        </div>
    );
}

export default IndexFacture;
